<template>
    <form ref="form" @submit.prevent>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원노출여부</span>
            <span class="txt">
                관리자용 프로그램의 스케줄표 및 회원예약 어플리케이션에서 강사 노출 여부를 일괄 설정할 수 있는
                부분입니다.
            </span>
        </div>

        <div class="com-table-top">
            <table class="com-table">
                <colgroup>
                    <col style="width: 215px" />
                    <col style="width: 270px" />
                    <col style="width: 270px" />
                    <col style="width: 270px" />
                    <col style="width: 270px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>직원명</th>
                        <th>직급/권한</th>
                        <th>스케줄표 노출설정</th>
                        <th>회원예약 어플리케이션 노출설정</th>
                        <th>모든 알림 수신설정</th>
                    </tr>
                </thead>
                <tbody v-if="isLoading">
                    <loading-spinner></loading-spinner>
                </tbody>
                <tbody>
                    <tr v-for="(item, index) in data" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.centerStaffRole.roleName }}</td>
                        <td>
                            <div class="com-design-check red">
                                <input :id="`schedule-${index}`" v-model="item.scheduleShowYn" type="checkbox" />
                                <label :for="`schedule-${index}`"></label>
                            </div>
                        </td>
                        <td>
                            <div class="com-design-check blue">
                                <input :id="`reservation-${index}`" v-model="item.reserveShowYn" type="checkbox" />
                                <label :for="`reservation-${index}`"></label>
                            </div>
                        </td>
                        <td>
                            <div class="com-design-check green">
                                <input :id="`notification-${index}`" v-model="item.appPushAllYn" type="checkbox" @click='() => onClickPushYn(item)' />
                                <label :for="`notification-${index}`"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="bottom-btn">
            <btn-loading-spinner v-if="isSaving"></btn-loading-spinner>
            <template v-else>
                <button class="com-btn" type="reset">취소</button>
                <button class="com-btn blue" type="button" @click="save">저장</button>
            </template>
        </div>
    </form>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'SettingEmployeeCheck',
    components: { LoadingSpinner, BtnLoadingSpinner },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            loginCenterId: '',
            isLoading: false,
            isSaving: false,
            centerStaffId: this.$route.params.centerStaffId,
            data: {},
            classTypes: {},
        };
    },
    async beforeMount() {
        this.loginCenterId = parseInt(this.cId);
        if (this.loginCenterId == 0) {
            location.href = '/login';
        }

        (await this.$getSystemCode({ center_staff: ['class_type_cd'] })).forEach((o) => {
            o.forEach((e) => (this.classTypes[e.codeName] = e.codeDesc));
        });

        this.load();
    },
    mounted() {},
    methods: {
        load() {
            this.isLoading = true;
            api.get(`/admin/api/center/${this.loginCenterId}/staff/teachers/list`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    Utils.getSort(this.data, 'name');
                    // this.data.sort((o1, o2) => (o1.name < o2.name ? -1 : 1));
                    // this.data.sort((o1, o2) => { return (Number(o1.match(/(\d+)/g)[0]) - Number((o2.match(/(\d+)/g)[0]))); });
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        save() {
            this.isSaving = true;
            api.post(`/admin/api/center/${this.loginCenterId}/staff/showInfo`, {
                showInfo: this.data.map((o) => {
                    const { centerStaffId, scheduleShowYn, reserveShowYn, appPushAllYn } = o;
                    return { centerStaffId, scheduleShowYn, reserveShowYn, appPushAllYn };
                }),
            })
                .then((res) => {
                    this.isSaving = false;
                })
                .catch((res) => {
                    this.isSaving = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        onClickPushYn(item) {
            if (!item.appPushAllYn) {
                this.data.forEach((staff, index) => {
                    if (staff.centerStaffId !== item.centerStaffId) {
                        this.data.splice(index, 1, {...staff, appPushAllYn: false});
                    }
                })
            }
        },
    },
};
</script>
<style lang="scss">
.bottom-btn {
    .spinner-container {
        margin: auto;
    }
}
</style>
